/**
 * Loads ArcGIS map UI web components (ESM-only) without going through
 * TypeScript's CommonJS/node16 static analysis of map.ts.
 *
 * ScaleBar / Zoom widgets are deprecated since 4.32 in favour of these components.
 */

/**
 * @param {import('@arcgis/core/views/MapView').default} view
 * @returns {Promise<void>}
 */
export async function attachMapChrome(view) {
  await Promise.all([
    import('@esri/calcite-components/calcite/calcite.css'),
    import('@arcgis/map-components/components/arcgis-scale-bar'),
    import('@arcgis/map-components/components/arcgis-zoom'),
  ]);

  const zoom = document.createElement('arcgis-zoom');
  zoom.view = view;
  view.ui.add(zoom, { position: 'bottom-right' });

  const scaleBar = document.createElement('arcgis-scale-bar');
  scaleBar.view = view;
  scaleBar.unit = 'dual';
  view.ui.add(scaleBar, { position: 'bottom-right' });
}
